import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from 'primereact/tabview';
import { DoughnutChart2 } from "../doughnutChart2";
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from 'axios';
import formattedDate from "../../../formatDate";
import mapTypeCtr from "../../../mapContrat";
import mapTypePaie from "../../../mapTypePaie";
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';

const apiUrl = process.env.REACT_APP_API_URL;

export const DashRetard2 = () => {
  const [visible, setVisible] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [sansPaienement, setSansPaienement] = useState([]);
  const [retard,setRetard] = useState([]);


  const [infoLocation, setInfoLocation] = useState([]);
  const [infoFacture, setInfoFacture] = useState([]);
  const [infoPaie, setInfoPaie] = useState([]);
  const [infoContrat, setInfoContrat] = useState([]);
  const [locationVisible, setLocationVisible] = useState(false);
  

   const handleClick = async (idStockage, idClient) => {
     //Clique du numero de stockage
     try {
       const response = await axios.get(
         `${apiUrl}/IHM/api/suggestion.php?idStockage=${idStockage}&idClient=${idClient}`
       );
       setInfoLocation(response.data);
       setLocationVisible(true);

       const factureResponse = await axios.get(
         `${apiUrl}/IHM/api/suggestion.php?idClient=${idClient}&facture`
       );
       setInfoFacture(factureResponse.data);

       const paieResponse = await axios.get(
         `${apiUrl}/IHM/api/suggestion.php?idClient=${idClient}&paiement`
       );
       setInfoPaie(paieResponse.data);

       const contratResponse = await axios.get(
         `${apiUrl}/IHM/api/suggestion.php?idClient=${idClient}&contrat`
       );
       setInfoContrat(contratResponse.data);
     } catch (error) {
       console.error("Erreur lors de la récupération des suggestions", error);
     }
   };

useEffect(() => {
  axios
    .get(`${apiUrl}/IHM/api/infoDashboard.php?sansPaiement`)
    .then((response) => {
      setSansPaienement(response.data);
    })
    .catch((error) => {
      console.error(
        "Erreur lors du chargement des fiches abandonnées :",
        error
      );
    });
}, []);

useEffect(() => {
  axios
    .get(`${apiUrl}/IHM/api/infoDashboard.php?retardPaiem`)
    .then((response) => {
      setRetard(response.data);
    })
    .catch((error) => {
      console.error(
        "Erreur lors du chargement des fiches abandonnées :",
        error
      );
    });
}, []);

const copyToClipboard = (text) => {
  if (text !== "") {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedText(text);
          setOpenSnackbar(true);
        })
        .catch((error) => {
          console.error(
            "Erreur lors de la copie dans le presse-papiers : ",
            error
          );
        });
    } else {
      // Utiliser l'API de sélection de texte comme solution de secours
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      setCopiedText(text);
      setOpenSnackbar(true);
    }
  }
};
const handleCloseSnackbar = () => {
  setOpenSnackbar(false);
};
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <div>
        <div
          className="contRetard"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span
            style={{ fontWeight: "600", cursor: "pointer", zIndex: "22" }}
            onClick={() => setVisible(true)}
          >
            Détails de retard <HelpIcon sx={{ fontSize: 14 }} />
          </span>
        </div>
        <DoughnutChart2 />
      </div>

      <Dialog
        visible={visible}
        style={{ width: "70vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <TabView>
          <TabPanel header="Sans paiement">
            <DataTable
              value={sansPaienement}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {sansPaienement.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column
                header="Client"
                style={{ cursor: "pointer" }}
                field="nom"
                body={(rowData) => (
                  <span
                    onClick={() =>
                      handleClick(rowData.idStockage, rowData.idClient)
                    }
                  >
                    {rowData.nom} <InfoIcon sx={{ fontSize: "14px" }} />
                  </span>
                )}
              />

              <Column
                header="Box"
                field="idStockage"
                body={(rowData) => (
                  <span>{rowData.idStockage.split("||").join(",")}</span>
                )}
              />

              <Column
                style={{ cursor: "pointer" }}
                field="mail"
                header="Email"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => (
                  <div>
                    <span
                      onClick={() => {
                        copyToClipboard(rowData.mail);
                      }}
                    >
                      {rowData.mail}
                    </span>
                  </div>
                )}
              />

              <Column
                style={{ cursor: "pointer" }}
                field="num1"
                header="Tél"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => (
                  <div>
                    <span
                      onClick={() => {
                        copyToClipboard(rowData.num1);
                      }}
                    >
                      {rowData.num1}
                    </span>
                  </div>
                )}
              />
            </DataTable>
          </TabPanel>
          <TabPanel header="Retard de paiement">
            <DataTable
              value={retard}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {retard.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column
                header="Client"
                style={{ cursor: "pointer" }}
                field="nom"
                body={(rowData) => (
                  <span
                    onClick={() =>
                      handleClick(rowData.idStockage, rowData.idClient)
                    }
                  >
                    {rowData.nom} <InfoIcon sx={{ fontSize: "14px" }} />
                  </span>
                )}
              />

              <Column
                header="Box"
                field="idStockage"
                body={(rowData) => (
                  <span>{rowData.idStockage.split("||").join(",")}</span>
                )}
              />

              <Column
                style={{ cursor: "pointer" }}
                field="mail"
                header="Email"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => (
                  <div>
                    <span
                      onClick={() => {
                        copyToClipboard(rowData.mail);
                      }}
                    >
                      {rowData.mail}
                    </span>
                  </div>
                )}
              />

              <Column
                style={{ cursor: "pointer" }}
                field="num1"
                header="Tél"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => (
                  <div>
                    <span
                      onClick={() => {
                        copyToClipboard(rowData.num1);
                      }}
                    >
                      {rowData.num1}
                    </span>
                  </div>
                )}
              />
              <Column
                style={{ cursor: "pointer" }}
                field="dernierPaiement"
                header="Echéance"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => {
                  if (rowData.dernierPaiement) {
                    const date = new Date(rowData.dernierPaiement);
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const year = date.getFullYear();
                    return (
                      <span>
                        {day}/{month}/{year}{" "}
                      </span>
                    );
                  } else {
                    return <span>Aucune</span>;
                  }
                }}
              />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>

      <Dialog
        visible={locationVisible}
        modal
        style={{ width: "70vw" }}
        onHide={() => {
          if (!locationVisible) return;
          setLocationVisible(false);
        }}
      >
        <TabView>
          <TabPanel header="Location">
            <DataTable value={infoLocation}>
              <Column header="Client" field="nom" />
              <Column
                header="Box"
                field="idStockage"
                body={(rowData) => (
                  <span>{rowData.idStockage.split("||").join(",")}</span>
                )}
              />
              <Column
                header="Volume"
                field="totVolume"
                body={(rowData) => <span>{rowData.totVolume} m³</span>}
              />
              <Column
                header="Loyer"
                field="loyer"
                body={(rowData) => <span>{rowData.loyer} €</span>}
              />
              <Column
                field="dateReservation"
                header=" R/E"
                style={{ width: "20%" }}
                bodyStyle={{ fontSize: "13px" }}
                body={(rowData) => (
                  <div>
                    R: {formattedDate(rowData.dateReservation)} <br />
                    E: {formattedDate(rowData.dateEntree)}
                  </div>
                )}
              />
              <Column header="Notes" field="noteLocation" />
            </DataTable>
          </TabPanel>
          <TabPanel header="Facture(s)">
            <DataTable value={infoFacture}>
              <Column
                field="numFact"
                header="Ref"
                bodyStyle={{ cursor: "pointer" }}
                body={(rowData) => (
                  <span onClick={() => copyToClipboard(rowData.numFact)}>
                    {rowData.numFact}
                  </span>
                )}
              />
              <Column field="nom" header="Client" />
              <Column
                field="dateEnv"
                header="Envoi"
                body={(rowData) => (
                  <span>{formattedDate(rowData.dateEnv)}</span>
                )}
              />
              <Column field="typeFact" header="Type" />
              <Column
                field="idPaiement"
                header="Paiement"
                bodyStyle={{ cursor: "pointer" }}
                body={(rowData) => (
                  <span onClick={() => copyToClipboard(rowData.idPaiement)}>
                    {rowData.idPaiement}
                  </span>
                )}
              />
              <Column
                field=""
                header="Période"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => (
                  <span>
                    D:{formattedDate(rowData.dateDebut)}
                    <br />
                    F:{formattedDate(rowData.dateFin)}
                  </span>
                )}
              />
              <Column header="Notes" field="note" />
            </DataTable>
          </TabPanel>
          <TabPanel header="Paiement(s)">
            <DataTable value={infoPaie}>
              <Column header="Ref" field="idPaiement" />
              <Column
                header="Type"
                field="typePaie"
                body={(rowData) => <span>{mapTypePaie(rowData.typePaie)}</span>}
              />
              <Column header="Client" field="nom" />
              <Column
                header="Envoi"
                field="datePaie"
                body={(rowData) => (
                  <span>{formattedDate(rowData.datePaie)}</span>
                )}
              />
              <Column
                header="Période"
                field="dateFin"
                bodyStyle={{ fontSize: "14px" }}
                body={(rowData) => (
                  <span>
                    D:{formattedDate(rowData.dateDebut)}
                    <br />
                    F:{formattedDate(rowData.dateFin)}
                  </span>
                )}
              />
              <Column
                header="Montant"
                field="valeurPaie"
                body={(rowData) => <span>{rowData.valeurPaie}€</span>}
              />
            </DataTable>
          </TabPanel>
          <TabPanel header="Contrat">
            <DataTable value={infoContrat}>
              <Column
                field="typeContrat"
                header="Type"
                body={(rowData) => (
                  <span>{mapTypeCtr(rowData.typeContrat)}</span>
                )}
              />
              <Column
                field="dateContrat"
                header="Date du contrat"
                body={(rowData) => (
                  <span>{formattedDate(rowData.dateContrat)}</span>
                )}
              />
              <Column header="Client" field="nom" />
              <Column
                field="lienCtr"
                header="Lien du contrat"
                style={{ width: "10vw", maxWidth: "10vw" }}
                body={(rowData) => {
                  const urlPattern = /^(https?:\/\/)/;
                  const link = urlPattern.test(rowData.lienCtr)
                    ? rowData.lienCtr
                    : null;

                  return link ? (
                    <a
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "10vw",
                        color: "#146C94",
                      }}
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {rowData.lienCtr}
                    </a>
                  ) : (
                    <span
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "10vw",
                        color: "#999", // Couleur grise pour indiquer un état "en attente"
                      }}
                    >
                      {rowData.lienCtr}
                    </span>
                  );
                }}
              />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>
    </>
  );
};
